import { render, staticRenderFns } from "./Verifications.vue?vue&type=template&id=8a2ea490&scoped=true&"
import script from "./Verifications.vue?vue&type=script&lang=js&"
export * from "./Verifications.vue?vue&type=script&lang=js&"
import style0 from "./Verifications.vue?vue&type=style&index=0&id=8a2ea490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2ea490",
  null
  
)

export default component.exports